import { z } from "zod/v4";

import { ExclusionGroupDtoSchema } from "../../../../dtos/exclusion-group";

export const PluginExclusionGroupEntity_2023_08_20 = z.object({
  id: z.uuid().optional(),
  entityId: z.uuid(),
  percentage: z.number(),
  order: z.number(),
  hasPriorityOrder: z.boolean().default(false),
});

export const PluginExclusionGroupSchema_2023_08_20 =
  ExclusionGroupDtoSchema.extend({
    exclusionGroupEntities: PluginExclusionGroupEntity_2023_08_20.array(),
  });

export type PluginExclusionGroupType_2023_08_20 = z.infer<
  typeof PluginExclusionGroupSchema_2023_08_20
>;
